import type React from 'react'
import { type FunctionComponent, useEffect, useState } from 'react'

type Props = {
  filter: CharityFilterType
  setFilter: React.Dispatch<React.SetStateAction<CharityFilterType>>
}

export const CharityNameFilter: FunctionComponent<Props> = ({ filter, setFilter }) => {
  const [isTyping, setIsTyping] = useState(false)
  const [value, setValue] = useState(filter?.name)

  useEffect(() => {
    const id = setTimeout(
      () => {
        setFilter(prevState => ({
          ...prevState,
          name: value
        }))
        setIsTyping(false)
      },
      window?.Cypress ? 0 : 500
    )

    return () => clearTimeout(id)
  }, [value])

  return (
    <div className="relative">
      <label htmlFor="nameSearch" className="label">
        Name
      </label>
      <input
        id="nameSearch"
        type="text"
        value={value}
        onChange={({ target }) => {
          setIsTyping(true)
          setValue(target.value)
        }}
        className="border border-gray-300 rounded px-3 py-2 bg-white w-full focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent"
      />
      <div className="absolute right-sm -bottom-[0.15rem]">{isTyping && <div className="loadingSpinner" />}</div>
    </div>
  )
}
